import { PageMode } from '@confluence/page-utils/entry-points/enums';
import { useGetPageMode } from '@confluence/page-utils/entry-points/useGetPageMode';
import { useReadTime } from '@confluence/read-time/entry-points/useReadTime';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData';

import { useAIRovoButtonEnablement } from '../ai-smart-button/useAIRovoButtonEnablement';

/**
 * Hook to determine if nudge recommendation checks should be enabled
 *
 * @param contentId
 * @param contentType
 * @returns boolean indicating if nudge recommendation checks are enabled
 */
export const useNudgeRecommendationFilter = (contentId: string, contentType: string): boolean => {
	const { isAdminHubAIEnabled } = useSessionData();
	const pageMode = useGetPageMode();
	const isRovoButtonEnabled = useAIRovoButtonEnablement();

	const { readTime: readTimeMinutes, loading: readTimeLoading } = useReadTime(
		contentId,
		!isAdminHubAIEnabled || pageMode === PageMode.EDIT,
	);

	/**
	 * Filters to prevent high request volume checking for nudge recommendations
	 * 1. Rovo Button must be enabled
	 * 2. Content type must be 'page' (TODO: extend to 'blogpost' when backend 500s are fixed)
	 * 3. Page must not be in edit mode
	 * 4. Read time query must be completed
	 * 5. Read time must be available and more than 30 seconds
	 */
	return (
		isRovoButtonEnabled &&
		contentType === 'page' &&
		pageMode !== PageMode.EDIT &&
		!readTimeLoading &&
		Number(readTimeMinutes) > 0.5
	);
};
